import React, { useState, useEffect } from 'react';
import image1 from './Images/1.png'
import image2 from './Images/2.png'
import image3 from './Images/3.png'
import image4 from './Images/4.png'
import image5 from './Images/5.png'
import image6 from './Images/6.png'
import image7 from './Images/7.png'
import image8 from './Images/8.png'
import image9 from './Images/9.png'
import image10 from './Images/10.png'
import image11 from './Images/11.png'
import image12 from './Images/12.png'
import image13 from './Images/13.png'
function FooterCarousel() {
  const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9, image10, image11, image12, image13];
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    
    const interval = setInterval(() => {
      slideTo((current + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [current, images.length, isPaused]);

  const slideTo = (index) => {
    if (isTransitioning || index === current) return;
    setPrev(current);
    setCurrent(index);
    setIsTransitioning(true);

    setTimeout(() => {
      setPrev(null);
      setIsTransitioning(false);
    }, 600);
  };

  const prevSlide = () => {
    slideTo(current === 0 ? images.length - 1 : current - 1);
  };

  const nextSlide = () => {
    slideTo((current + 1) % images.length);
  };

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  // Handle touch events for mobile
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextSlide();
    } else if (isRightSwipe) {
      prevSlide();
    }
  };

  return (
    <div 
      className="carousel-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <button 
        className="arrow left-arrow" 
        onClick={prevSlide}
        aria-label="Previous image"
        disabled={isTransitioning}
      >
        &#10094;
      </button>

      {/* Previous image (fading out) */}
      {prev !== null && (
        <img
          src={images[prev]}
          alt={`Gallery image ${prev + 1}`}
          className="carousel-image fade-out"
          key={`prev-${prev}`}
          loading="lazy"
        />
      )}

      {/* Current image (fading in) */}
      <img
        src={images[current]}
        alt={`Gallery image ${current + 1}`}
        className="carousel-image fade-in"
        key={`current-${current}`}
        loading="lazy"
      />

      <button 
        className="arrow right-arrow" 
        onClick={nextSlide}
        aria-label="Next image"
        disabled={isTransitioning}
      >
        &#10095;
      </button>

      {/* Dot indicators */}
      <div className="carousel-dots">
        {images.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === current ? 'active' : ''}`}
            onClick={() => slideTo(index)}
            aria-label={`Go to image ${index + 1}`}
            disabled={isTransitioning}
          />
        ))}
      </div>
    </div>
  );
}

export default FooterCarousel;